import apiInstance from "../Api/ApiInstance";

export async function Register(values) {
  return await apiInstance.post("api/nexus-main/user", values);
}

export async function UpdateUser(values) {
  return await apiInstance.patch(
    "api/nexus-main/user/updateUser",
    values
  );
}

export async function UpdatePassword(values) {
  return await apiInstance.patch(
    "api/nexus-main/user/updatePassword",
    values
  );
}
